export const RecentProjects = () => {
  return (
		<section className="py-24 w-full bg-gradient-to-br from-slate-50 via-blue-50 to-gray-50 flex justify-center overflow-x-clip">
			<div className="container max-w-7xl 2xl:max-w-[1600px] mx-auto relative z-10">
				<div className="text-center mb-16">
					<h2 className="text-4xl md:text-5xl font-extrabold text-navy mb-4 tracking-tight drop-shadow-sm">
						Project Capabilities
					</h2>
					<p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
						Explore the types of Central Texas development work our services
						support from early planning through permitting and coordination.
					</p>
				</div>
				<div className="grid md:grid-cols-3 gap-10">
					{/* Project Card 1 */}
					<div className="relative group rounded-2xl overflow-hidden shadow-xl border border-blue/10 bg-white/90 transition-transform hover:-translate-y-2 duration-300">
						<div className="aspect-[4/3] w-full overflow-hidden">
							<img
								src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
								alt="Construction site with excavation and utilities"
								loading="lazy"
								decoding="async"
								className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
							/>
						</div>
						<div className="absolute inset-0 bg-navy/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end rounded-2xl">
							<div className="p-8 text-white">
								<h3 className="text-2xl font-bold mb-2">
									RESIDENTIAL SUBDIVISION
								</h3>
								<p className="text-base opacity-90">
									Site layout, grading, drainage, utilities, platting, and agency coordination for residential development.
								</p>
							</div>
						</div>
						<div className="p-6">
							<h3 className="text-xl font-semibold mb-1 text-navy">
								RESIDENTIAL SUBDIVISION
							</h3>
							<p className="text-sm text-muted-foreground">
								Site layout, grading, drainage, utilities, platting, and agency coordination for residential development.
							</p>
						</div>
					</div>
					{/* Project Card 2 */}
					<div className="relative group rounded-2xl overflow-hidden shadow-xl border border-blue/10 bg-white/90 transition-transform hover:-translate-y-2 duration-300">
						<div className="aspect-[4/3] w-full overflow-hidden">
							<img
								src="https://images.unsplash.com/photo-1589939705384-5185137a7f0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
								alt="Modern office building construction"
								loading="lazy"
								decoding="async"
								className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
							/>
						</div>
						<div className="absolute inset-0 bg-navy/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end rounded-2xl">
							<div className="p-8 text-white">
								<h3 className="text-2xl font-bold mb-2">
									COMMERCIAL SITE PLAN
								</h3>
								<p className="text-base opacity-90">
									Permit-ready site planning and civil design for commercial properties across Central Texas.
								</p>
							</div>
						</div>
						<div className="p-6">
							<h3 className="text-xl font-semibold mb-1 text-navy">
								COMMERCIAL SITE PLAN
							</h3>
							<p className="text-sm text-muted-foreground">
								Permit-ready site planning and civil design for commercial properties across Central Texas.
							</p>
						</div>
					</div>
					{/* Project Card 3 */}
					<div className="relative group rounded-2xl overflow-hidden shadow-xl border border-blue/10 bg-white/90 transition-transform hover:-translate-y-2 duration-300">
						<div className="aspect-[4/3] w-full overflow-hidden">
							<img
								src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
								alt="Urban infrastructure and utilities"
								loading="lazy"
								decoding="async"
								className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
							/>
						</div>
						<div className="absolute inset-0 bg-navy/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end rounded-2xl">
							<div className="p-8 text-white">
								<h3 className="text-2xl font-bold mb-2">
									CITY OF AUSTIN TAP PLAN
								</h3>
								<p className="text-base opacity-90">
									Development of a TAP in coordination
									with site and infrastructure design for a growing subdivision
									in Travis County.
								</p>
							</div>
						</div>
						<div className="p-6">
							<h3 className="text-xl font-semibold mb-1 text-navy">
								CITY OF AUSTIN TAP PLAN
							</h3>
							<p className="text-sm text-muted-foreground">
								Development of a TAP in coordination with
								site and infrastructure design for a growing subdivision in
								Travis County.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
